import onLayerReady from '../onLayerReady/index.js';
import onLayerUpdate from '../onLayerUpdate/index.js';

var onLayerChange = function onLayerChange(layerProvider, layerId, callback) {
  var excludeKeys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var options = arguments.length > 4 ? arguments[4] : undefined;
  var unsubscribeFromReady = onLayerReady(layerProvider, layerId, callback);
  var unsubscribeFromUpdate = onLayerUpdate(layerProvider, layerId, callback, excludeKeys, options);
  return function () {
    unsubscribeFromReady && unsubscribeFromReady();
    unsubscribeFromUpdate && unsubscribeFromUpdate();
  };
};

export { onLayerChange as default };
